import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "attrs"];

/*
 * @Author: wangshengqiang
 * @Date: 2021-06-30 16:50:18
 * @LastEditTime: 2021-07-02 10:21:46
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React from 'react';
import classnames from 'classnames';
import { Button } from 'zarm';
import { getLocalClick } from '@/components/Button';
const Btn = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    className,
    attrs
  } = props,
        others = _objectWithoutProperties(props, _excluded);

  const {
    button = [],
    isShow
  } = attrs;
  const cls = classnames({
    'components-btn-render': true,
    [className]: !!className
  });
  const items = button.map((item = {}, index) => {
    const {
      text,
      events = {}
    } = item;
    const onClick = getLocalClick(events);

    if (!text) {
      return null;
    }

    return /*#__PURE__*/React.createElement(Button, {
      className: "btn",
      theme: "primary",
      onClick: onClick,
      key: index
    }, text);
  });

  if (!isShow) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), items);
});
export default Btn;